import { Type, Static } from '@sinclair/typebox'

export const PermissionConditionOperatorEqualsTB = Type.Literal('===')
export const PermissionConditionOperatorNotEqualsTB = Type.Literal('!==')
export const PermissionConditionOperatorGreaterThanTB = Type.Literal('>')
export const PermissionConditionOperatorGreaterThanOrEqualTB = Type.Literal('>=')
export const PermissionConditionOperatorLessThanTB = Type.Literal('<')
export const PermissionConditionOperatorLessThanOrEqualTB = Type.Literal('<=')
export const PermissionConditionOperatorAddTB = Type.Literal('+')
export const PermissionConditionOperatorSubtractTB = Type.Literal('-')
export const PermissionConditionOperatorMultiplyTB = Type.Literal('*')
export const PermissionConditionOperatorDivideTB = Type.Literal('/')
export const PermissionConditionOperatorAndTB = Type.Literal('AND')
export const PermissionConditionOperatorOrTB = Type.Literal('OR')
export const PermissionConditionOperatorInTB = Type.Literal('IN')
export const PermissionConditionOperatorNotInTB = Type.Literal('NOT IN')
export const PermissionConditionOperatorLikeTB = Type.Literal('LIKE')
export const PermissionConditionOperatorNotLikeTB = Type.Literal('NOT LIKE')

export const PermissionConditionOperatorTB = Type.Union([
  PermissionConditionOperatorEqualsTB,
  PermissionConditionOperatorNotEqualsTB,
  PermissionConditionOperatorGreaterThanTB,
  PermissionConditionOperatorGreaterThanOrEqualTB,
  PermissionConditionOperatorLessThanTB,
  PermissionConditionOperatorLessThanOrEqualTB,
  PermissionConditionOperatorAddTB,
  PermissionConditionOperatorSubtractTB,
  PermissionConditionOperatorMultiplyTB,
  PermissionConditionOperatorDivideTB,
  PermissionConditionOperatorAndTB,
  PermissionConditionOperatorOrTB,
  PermissionConditionOperatorInTB,
  PermissionConditionOperatorNotInTB,
  PermissionConditionOperatorLikeTB,
  PermissionConditionOperatorNotLikeTB,
])
export type PermissionConditionOperatorT = Static<typeof PermissionConditionOperatorTB>

// TODO: is there a better way to express the possibility space of our conditions in TB than Type.String()? regex?
export const PermissionConditionTB = Type.Recursive(This => Type.Object({
  left: Type.Union([Type.String(), This]),
  operator: PermissionConditionOperatorTB,
  right: Type.Union([Type.String(), This])
}))
export type PermissionConditionT = Static<typeof PermissionConditionTB>

// TODO: ideal if record key was typed to be dependent on actual entity fields, per-entity
// TODO: this only goes a single level deep atm - probably don't need more than that, but could go recursive where the value of this record is essentially PermissionValueTB
export const PermissionFieldLevelPermissionsTB = Type.Record(Type.String(), Type.Union([Type.Boolean(), PermissionConditionTB]))
export type PermissionFieldLevelPermissionsT = Static<typeof PermissionFieldLevelPermissionsTB>

export const PermissionTypeCreateTB = Type.Literal('create')
export const PermissionTypeReadTB = Type.Literal('read')
export const PermissionTypeUpdateTB = Type.Literal('update')
export const PermissionTypeDeleteTB = Type.Literal('delete')

export const PermissionTypeTB = Type.Union([
  PermissionTypeCreateTB,
  PermissionTypeReadTB,
  PermissionTypeUpdateTB,
  PermissionTypeDeleteTB
])
export type PermissionTypeT = Static<typeof PermissionTypeTB>

export const PermissionValueTB = Type.Union([Type.Boolean(), PermissionConditionTB, PermissionFieldLevelPermissionsTB])
export type PermissionValueT = Static<typeof PermissionValueTB>

export const PermissionSetTB = Type.Object({
  create: Type.Optional(PermissionValueTB),
  read: Type.Optional(PermissionValueTB),
  update: Type.Optional(PermissionValueTB),
  delete: Type.Optional(PermissionValueTB)
})
export type PermissionSetT = Static<typeof PermissionSetTB>

// TODO: move to role.ts?
export const PermissionRoleCreatorTB = Type.Literal('creator')
export const PermissionRoleViewerTB = Type.Literal('viewer')
export const PermissionRoleEditorTB = Type.Literal('editor')
export const PermissionRoleOwnerTB = Type.Literal('owner')
export const PermissionRoleMemberTB = Type.Literal('member')
export const PermissionRoleReportManagerTB = Type.Literal('reportManager')
export const PermissionRoleReportViewerTB = Type.Literal('reportViewer')
export const PermissionRoleAdministratorTB = Type.Literal('administrator')
// roles
export const PermissionRoleOrgAdminTB = Type.Literal('orgAdmin')
export const PermissionRoleReportManagerInternalTB = Type.Literal('reportManagerInternal')
export const PermissionRoleReportManagerExternalTB = Type.Literal('reportManagerExternal')
export const PermissionRoleReportViewerInternalTB = Type.Literal('reportViewerInternal')
export const PermissionRoleReportViewerExternalTB = Type.Literal('reportViewerExternal')
export const PermissionRoleMetaOrgAdminTB = Type.Literal('metaOrgAdmin')
export const PermissionRoleMetaOrgMemberTB = Type.Literal('metaOrgMember')
// ruminati roles
export const PermissionRoleSupportUserTB = Type.Literal('supportUser')

export const PermissionRoleTB = Type.Union([
  PermissionRoleCreatorTB,
  PermissionRoleViewerTB,
  PermissionRoleEditorTB,
  PermissionRoleOwnerTB,
  PermissionRoleMemberTB,
  PermissionRoleReportManagerTB,
  PermissionRoleReportViewerTB,
  PermissionRoleAdministratorTB,
  PermissionRoleOrgAdminTB,
  PermissionRoleReportManagerInternalTB,
  PermissionRoleReportManagerExternalTB,
  PermissionRoleReportViewerInternalTB,
  PermissionRoleReportViewerExternalTB,
  PermissionRoleMetaOrgAdminTB,
  PermissionRoleMetaOrgMemberTB,
  PermissionRoleSupportUserTB
])
export type PermissionRoleT = Static<typeof PermissionRoleTB>
